import { JSONSchemaType } from 'ajv'

export interface IConduccoConnectorFormData {
  connectorTypeId: string
  connectorName: string
  connectorJson: string
  inputParams: string
  outputParams: string
  isInactive: boolean
}

const ConduccoConnectorSchema: JSONSchemaType<IConduccoConnectorFormData> = {
  type: 'object',
  properties: {
    connectorTypeId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    connectorName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    connectorJson: {
      type: 'string',
    },
    inputParams: {
      type: 'string',
    },
    outputParams: {
      type: 'string',
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['connectorTypeId', 'connectorName'],
  additionalProperties: false,
}

export default ConduccoConnectorSchema
